import React from "react";
import { CampaignHero, OutcomeCTA } from "../components/CampaignHero";
import ThreeProducts from "../components/ThreeProducts";
import { ExperienceArchitecture, DecisionDeliverables } from "../components/ExperienceArchitecture";
import { PartnersTeaser } from "../components/PartnersTeaser";
import { HeliosSystemMap } from "../components/HeliosSystemMap";

export default function ProductPage({ onDemo }) {
  return <main data-testid="product-page" className="campaign-page">
    <CampaignHero id="product" image="product" eyebrow="Helios · Helios Brain · Helios Factory" title={"Intelligence with\na way forward."} description="Understand your organization. Explore what is possible. Put the best achievable path into motion." onDemo={onDemo} footer="Your context. Your constraints. Your next move." />
    <ThreeProducts />
    <HeliosSystemMap id="product-system-map" />
    <DecisionDeliverables id="product" />
    <PartnersTeaser id="product" />
    <OutcomeCTA onDemo={onDemo} id="product" />
  </main>;
}